import {
  EAN13Checksum,
  EAN8Checksum,
} from "../PLU/PLUProductEdit/validPLUProduct";

export function isInputEAN(text: string) {
  return (
    (text.length === 13 && EAN13Checksum(text) === text[12]) ||
    (text.length === 8 && EAN8Checksum(text) === text[7])
  );
}
